const mutations = {
  setModels(state, data) {
    state.notaAlumnoExamens = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.notaAlumnoExamen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.notaAlumnoExamens.unshift(model);
  },

  updateModel(state, model) {
    const index = state.notaAlumnoExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.notaAlumnoExamens.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.notaAlumnoExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.notaAlumnoExamens.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
